module.exports = __webpack_public_path__ + "img/xny11.487483df.png";